export const processLicenses = ({licenses}) => {
  const licenseSet = new Set([
    'AbWorkplaceReservations',
    'AbSpaceHotelling',
    'AbMoveManagement',
    'AbCloudWorkplaceServices',
    'AbCloudSpaceManagement'
  ])

  // Get all of the enabled licenses that are contained in the above licenseSet
  const enabledLicenses = licenses
    .filter(license => {
      const {id, enabled} = license
      return enabled && licenseSet.has(id)
    })
    .reduce((acc, license) => {
      acc[license.id] = true
      return acc
    }, {})

  return {
    AbWorkplaceReservations: !!(
      enabledLicenses['AbWorkplaceReservations'] ||
      enabledLicenses['AbCloudWorkplaceServices']
    ),
    AbSpaceHotelling: !!(
      enabledLicenses['AbSpaceHotelling'] ||
      enabledLicenses['AbCloudWorkplaceServices']
    ),
    AbMoveManagement: !!(
      enabledLicenses['AbMoveManagement'] ||
      enabledLicenses['AbCloudSpaceManagement']
    )
  }
}
